module.exports = __webpack_public_path__ + "static/media/difdisplay-webfont.54926a4c.eot";